import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from "react-redux";
import { withStyles } from '@material-ui/core/styles';
import {
    WithStyles,
    createStyles,
    Button,
    MenuItem,
    Popover,
    MenuList,
    Link,
    Grid
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import contentService from '../../services/contentService';
import getDefaultFormData from '../../types/ContentFromDataDefault';
import { QUESTION_TYPE } from '../../../../constants/comman';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
// import { MenuData } from '../../common';
// import CustomInfoIcon from '../../common/CustomInfoIcon';
const styles = createStyles({
    variationSelect: {
        background: '#FFF !important',
        color: '#333 !important',
        marginRight: 6,
        border: '1px solid #dfdfdf',
        boxSizing: 'border-box',
        borderRadius: 4,
        fontSize: '14px',
        padding: '10px',
        maxWidth: '100%',
        width: '137px',
        fontFamily: "'Nunito', san-serif",   
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer'
    },
    variationLable:{
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: '100px',
    },
    dropdownList:{
        borderTop: '0',
        background: '#FFF !important',
        color: '#333 !important',
        marginRight: 6,
        border: '1px solid #dfdfdf',
        boxSizing: 'border-box',
        borderRadius: '0 0 4px 4px',                
        width: '137px',
        fontFamily: "'Nunito', san-serif",
        position: 'absolute',
        marginTop: '-3px',
        zIndex: 9,
        textAlign: 'left', 
        padding: '10px 12px',   
        overflow: 'auto',
        minHeight: '56px',
        '&>div':{
            paddingLeft: '1px',
        },
    },
    listItem:{
        fontSize: '14px',
        color: '#666',
        textAlign: 'left',
        paddingLeft: '0!important',
        paddingBottom: '18px',
        cursor: 'pointer',
        '&:hover':{
            color: '#333',
        }
    },
    arrowIcon:{
        '&>img':{
            transform: 'rotate(180deg)',
            // marginLeft: '43px',
        }
    },
    rotateImg:{
        transform: 'rotate(0deg)',
    },
    pl0:{
        paddingLeft: '0!important',
    },
    AddBtn: {
        fontSize: '14px',
        lineHeight: '19px',
        height: '28px',
        color: '#fff',
        width: '110px',
        backgroundColor: '#1D7DEA',
        '&:hover':{
            backgroundColor: '#1D7DEA',
        }
    },
});

interface VariationProps extends WithStyles<typeof styles> {
    content: any,
    publishedContent: any
}
interface VariationState {
    isHelpList: boolean,
    setAnchorEl: any,
    anchorEl: any,
    showTooltip: boolean,
    showDropdown: boolean,
    selectedOption: string
}

class Variation extends Component<VariationProps, VariationState>{    

    constructor(props: VariationProps, state: VariationState) {
        super();
        let self = this;
        self.state = {
            isHelpList: false,
            anchorEl: null,
            setAnchorEl: null,
            showTooltip: false,
            showDropdown: false,
            selectedOption: '',
        }
    }

    mouseHoverHandle = () => {
        this.setState({
            showTooltip: !this.state.showTooltip
        })
    }
    handleVariation = () =>{
        this.setState({
            showDropdown: !this.state.showDropdown
        })
    }
    handleSelect = (e: any, selectedItem: any) => {
        this.setState({...this.state, selectedOption: e.target.innerText, showDropdown: false }, () => {
            const {content} = this.props
            let {contentTypeCode, contentSubTypeCode} = content
            contentTypeCode = contentTypeCode.toString().trim()
            contentSubTypeCode = contentSubTypeCode.toString().trim()
            // let defaultFromData = getDefaultFormData(content.contentTypeCode)
            // defaultFromData['masterVariationQuestionId'] = content.content && content.content._id  
            // contentService
            // .save("", contentTypeCode, defaultFromData, false)
            // .then((res: any) => {
window.location.href = `/content/edit/${contentTypeCode}/${contentSubTypeCode}/${selectedItem._id}${contentTypeCode}?vKey=${selectedItem.no}`
            // })
        })
    }
//http://fb1-authors.mypat.in/content/edit/question/0/6006b44f587daa7b1dec4cd8question
    addVariation = () => {
    const {content, publishedContent} = this.props
    console.log(content)
    let {contentTypeCode, contentSubTypeCode} = content
    contentTypeCode = contentTypeCode.toString().trim()
    contentSubTypeCode = contentSubTypeCode.toString().trim()
    let defaultFromData = getDefaultFormData(content.contentSubTypeCode)
    if(contentSubTypeCode == 5) {
        let _id
        try {
            _id = content.content.content.find((x: any) => x.isParagraphRootNode).paragraphQuestionId
        } catch(e) {}
        defaultFromData['masterVariationQuestionId'] = _id  
    } else {
        defaultFromData['content'] = publishedContent ? publishedContent.content : content.content.content
        defaultFromData['masterVariationQuestionId'] = content.content && content.content._id  
    }
    defaultFromData['questionCode'] = parseInt(contentSubTypeCode)
    defaultFromData['questionType'] = QUESTION_TYPE[contentSubTypeCode]
    contentService
      .save("", contentTypeCode, defaultFromData, false)
      .then((res: any) => {
          console.log(res)
    //       contentService
    //       res['content'] = content.content.content
    //   .save(res.responseObject._id+contentTypeCode, contentTypeCode, res, false)
    //   .then((res: any) => {
    //   })
window.location.href = `/content/edit/${contentTypeCode}/${contentSubTypeCode}/${res.responseObject._id}${contentTypeCode}?vKey=${content.questionVariations.length+1}`
      })
    }

    renderList() {
        const {content, classes} = this.props
        return content.questionVariations.map((item: any, index: number) => {
            item.no = index+1
            return (<Grid
                onClick={e => this.handleSelect(e, item)}
                item
                className={[classes.listItem, classes.variationLable].join(' ')}>
                Variation {item.no}
                </Grid>)
        })
    }

    handleClickOutside = () => {
    
        if(this.state.showDropdown) {
            this.setState({
                showDropdown: false
            })
        }

    }


    
    render() {
        let self = this;
        const { classes, content } = this.props;
        const { anchorEl, showTooltip, showDropdown } = this.state;
        return (
            <>
               <ClickAwayListener onClickAway={this.handleClickOutside}> 
               <Grid>
                    <span className={classes.variationSelect} onClick={this.handleVariation}>
                        <span className={classes.variationLable}>{this.state.selectedOption ? this.state.selectedOption:'Variations' }</span> 
                        <span className={(showDropdown==true) ? classes.rotateImg: classes.arrowIcon}><img src="/assets/svg/myLibrary/chevron.svg"/></span>
                    </span>
                    {
                        showDropdown && 
                        <>
                            <Grid className={classes.dropdownList}>
                                <Grid>
                                    {/* <Grid onClick={e => this.handleSelect(e)} item className={[classes.listItem, classes.variationLable].join(' ')}>Variation 1</Grid>
                                    <Grid onClick={e => this.handleSelect(e)} item className={[classes.listItem, classes.variationLable].join(' ')}>Variation 2</Grid>
                                    <Grid onClick={e => this.handleSelect(e)} item className={[classes.listItem, classes.variationLable].join(' ')}>Variation 3</Grid>      */}
                                    {this.renderList()}
                                </Grid>   
                                <Grid container alignItems="center" justify="flex-start" className={classes.pl0}>
                                    <Grid item>
                                        <Button onClick={this.addVariation} className={classes.AddBtn}>+ Add </Button>  
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                    }              
                </Grid>
                </ClickAwayListener>


            </>
        );
    }
}

const mapStateToProps = (state: any) => ({
    publishedContent: state.questionCreate.publishedContent,
  });

// @ts-ignore
export default connect(
    mapStateToProps,
    null
    // @ts-ignore
  )(withStyles(styles)(Variation));